import React, {Component} from "react";
import FJResourcesRatioItem from "./FJResourcesRatioItem";
import cinematic from "../../../icon/ratio_cinematic.svg";
import cinematicPlatform from "../../../icon/ratio_cinematic_platform.svg";
import landscape from "../../../icon/ratio_landscape.svg";
import landscapePlatform from "../../../icon/ratio_landscape_platform.svg";
import social from "../../../icon/ratio_social.svg";
import socialPlatform from "../../../icon/ratio_social_platform.svg";
import square from "../../../icon/ratio_square.svg";
import squarePlatform from "../../../icon/ratio_square_platform.svg";
import vertical from "../../../icon/ratio_vertical.svg";
import verticalPlatform from "../../../icon/ratio_vertical_platform.svg";
import Style from "./FJResourcesRatioBox.module.less";
import FJLocalStore from "../../../store/FJLocalStore";
import FJViewConstant from "../../../constant/FJViewConstant";

class FJResourcesRatioBox extends Component {
  constructor(props) {
    super(props);
    this._ratioList = [
      {
        icon: landscape,
        platform: landscapePlatform,
        type: FJViewConstant.RATIO_LANDSCAPE,
      },
      {
        icon: square,
        platform: squarePlatform,
        type: FJViewConstant.RATIO_SQUARE,
      },
      {
        icon: vertical,
        platform: verticalPlatform,
        type: FJViewConstant.RATIO_VERTICAL,
      },
      {
        icon: social,
        platform: socialPlatform,
        type: FJViewConstant.RATIO_SOCIAL,
      },
      {
        icon: cinematic,
        platform: cinematicPlatform,
        type: FJViewConstant.RATIO_CINEMATIC,
      },
    ]
  }

  render() {
    const {currentRatioType} = this.props;
    const {changeRatioType, enterRatioItem, leaveRatioItem} = this.props;
    return (
      <div className={Style.ratio_box}>
        <p className={Style.ratio_title}>{FJLocalStore._('ratio')}</p>
        <div className={Style.ratio_list}>
          {
            this._ratioList.map(item => {
              return (
                <FJResourcesRatioItem icon={item.icon}
                                      platform={item.platform}
                                      key={item.icon}
                                      active={currentRatioType === item.type}
                                      onClick={() => changeRatioType(item.type)}
                                      onMouseEnter={() => enterRatioItem(item.type)}
                                      onMouseLeave={leaveRatioItem}/>
              )
            })
          }
        </div>
      </div>
    )
  }
}

export default FJResourcesRatioBox;
